import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter,
	Pagination, PaginationItem, PaginationLink
} from 'reactstrap';
import FileBase64 from 'react-file-base64';
import $ from 'jquery';
import StudentPage from '../../views/StudentPage/';
const GLOBAL = require('../../Globals');

class PhotoUpload extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			acyear: '',
			modal: false,
			_message: '',
			alertClass: '',
			posts: [],
			accyear: [],
			files: [],
			_redirect: false,
			currentPage: 1,
			todosPerPage: 3
		}
		this.onChange = this.onChange.bind(this);
		this.togglePrimary = this.togglePrimary.bind(this);
		this.showmodal = this.showmodal.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	//base64 photo
	getFiles(files) {
		this.setState({ files: files });
		console.log(this.state);
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		console.log(this.state);
	}

	showmodal() {

		this.setState({
			modal: !this.state.modal
		});

	}

	togglePrimary(e) {
		this.setState({
			modal: !this.state.modal
		});
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('student/uploadphoto', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Photo Uploaded Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.setState({ files: [] });
			}
			else {

				this.setState({
					_message: 'Error',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	handleClick(dd) {

		this.state.id = dd;
		console.log('id' + this.state.id);

		if (window.confirm("Do you want to Delete?")) {
			PostData('student/deletecategory', this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if (responseJson.status == '1') {
					this.setState({
						_message: 'Student Category Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error in Remove Student Category',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	componentDidMount() {

		this.getdata();
		this.getacyear();
	}

	getdata() {

		GetData('student/getcategory').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	/** get Academic Year **/
	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getclass();
			}
		});
	}

	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/leave/editcategory/' + this.state.idd} />);

		}

		var acyear = this.state.accyear;

		return (
			<div>
				<StudentPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="stcatform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>
										<strong>Student Photo Upload</strong>&emsp;&emsp;
										Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onChange} required id="year">
											<option value="">Select Academic Year</option>
											{
												acyear.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>
										<Button size="sm" className="btn-right" color="danger" onClick={this.showmodal}><i className="fa fa-info"></i> Instructions</Button>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="4">
												<FormGroup>
													<FileBase64 onDone={this.getFiles.bind(this)} multiple={true} />
												</FormGroup>
											</Col>
											<Modal isOpen={this.state.modal} toggle={this.togglePrimary} className={'modal-primary ' + this.props.className}>
												<ModalHeader toggle={this.togglePrimary}>Instructions</ModalHeader>
												<ModalBody>
													<Row>
														<Col md="12">
															<Card className="border-info">
																<CardBody className="">
																	<div className="alert alert-success">
																		<p><i className="fa fa-info-circle"></i>&nbsp; Upload the Students Profile Photos file name as Student register no. </p> <br />
																		<p><i className="fa fa-info-circle"></i>&nbsp; Ex : 1418.jpg</p>

																	</div>
																</CardBody>
															</Card>
														</Col>

													</Row>
												</ModalBody>

											</Modal>
										</Row>
									</CardBody>
									<CardFooter>
										<Button type="submit" size="sm" className="btn-right" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
									</CardFooter>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default PhotoUpload;


// WEBPACK FOOTER //
// ./src/student/PhotoUpload/PhotoUpload.js